import React from 'react';

const Error = () => <section>Error. Page Not Found!</section>;

export default Error;
